import { joinURL } from 'ufo'
import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime'

const operationsGenerator = createOperationsGenerator()

export default defineProvider<{ baseURL?: string }>({
  getImage (src, { modifiers }) {
    let baseURL = useRuntimeConfig().public.baseUrl || 'https://rc.khonyagar.com'

    const isAbsoluteUrl = /^(https?:)?\/\//i.test(src)
    
    if (!baseURL) throw new Error('static provider base url not set')

    if (isAbsoluteUrl) baseURL = ''

    const operations = operationsGenerator(modifiers)

    return {
      url: joinURL(baseURL as string, src + (operations ? '?' + operations : ''))
    }
  }
})